import React, { useState } from 'react';
import { CheckIcon, XIcon, ShieldCheckIcon, ChevronLeftIcon, ChevronRightIcon, ArrowRightIcon } from 'lucide-react';
import { CountdownTimer } from '../components/CountdownTimer';
import { CTAButton } from '../components/CTAButton';
import { TestimonialCard } from '../components/TestimonialCard';
import { FAQAccordion } from '../components/FAQAccordion';
import { SocialProofPopup } from '../components/SocialProofPopup';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/b2KSmMuvGvDQW6ngW7pLa6/Mockup_(SIN_FONDO).png';
const BONUS_1_IMAGE = 'https://cdn.magicpatterns.com/uploads/7x4m7BEL72A46t5ypoLFj2/Mockup_-_Bono_1.png';
const BONUS_2_IMAGE = 'https://cdn.magicpatterns.com/uploads/uoqqA91V5K5Zfkib8P4vsM/Mokcup_-_Bono_2.png';
const BONUS_3_IMAGE = 'https://cdn.magicpatterns.com/uploads/ragqf1KJPu1UKuSArkWibA/Mockup_-_Bono_3.png';
const PREVIEW_PAGES = ['https://cdn.magicpatterns.com/uploads/oFu6C5pN5d6TCvsizvGbta/Hoja_1.jpg', 'https://cdn.magicpatterns.com/uploads/uDkZUBAvfjTEyhhePduWYZ/Hoja_2.jpg', 'https://cdn.magicpatterns.com/uploads/g2MPkK2xxqi6VU2npGDSkt/Hoja_3.jpg', 'https://cdn.magicpatterns.com/uploads/2MkTBGDqgsyzFFsViUupgq/Hoja_4.jpg', 'https://cdn.magicpatterns.com/uploads/peP36WA2Bgn3xV7tjogxhw/Hoja_5.jpg', 'https://cdn.magicpatterns.com/uploads/o7s6Nmo3ThCNm92gS5e3Xp/Hoja_6.jpg'];
const SECTION_LINK = '#compra';
export function SalesPage() {
  const [currentPage, setCurrentPage] = useState(0);
  const nextPage = () => {
    setCurrentPage(prev => (prev + 1) % PREVIEW_PAGES.length);
  };
  const prevPage = () => {
    setCurrentPage(prev => (prev - 1 + PREVIEW_PAGES.length) % PREVIEW_PAGES.length);
  };
  return <div className="min-h-screen bg-white font-sans text-gray-900 pb-20" data-id="element-35">
      <CountdownTimer data-id="element-36" />
      <SocialProofPopup data-id="element-37" />

      {/* HERO SECTION */}
      <section className="pt-8 pb-12 px-4 md:pt-12 md:pb-20 bg-gradient-to-b from-white to-gray-50" data-id="element-38">
        <div className="max-w-4xl mx-auto text-center" data-id="element-39">
          <div className="inline-flex items-center justify-center bg-blue-100 text-blue-700 px-6 py-2 rounded-full mb-6" data-id="element-40">
            <span className="text-sm md:text-base font-medium uppercase tracking-wide" data-id="element-41">
              🧠 PARA HOMBRES CANSADOS DE LUCHAR CONTRA SÍ MISMOS
            </span>
          </div>

          <h1 className="text-4xl md:text-6xl font-black tracking-tight text-gray-900 mb-8 leading-tight" data-id="element-42">
            MegaPack · Salir Sin Luchar
          </h1>

          <div className="mb-6" data-id="element-43">
            <a href={SECTION_LINK} data-id="element-44">
              <img src={PRODUCT_IMAGE} alt="MegaPack Salir Sin Luchar" className="w-full max-w-lg mx-auto drop-shadow-2xl hover:scale-105 transition-transform duration-300 cursor-pointer" data-id="element-45" />
            </a>
          </div>

          <p className="text-xl md:text-2xl font-bold text-gray-900 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-46">
            El sistema completo para salir del porno{' '}
            <span className="bg-yellow-300 px-1" data-id="element-47">sin fuerza de voluntad</span>,{' '}
            <span className="bg-yellow-300 px-1" data-id="element-48">sin sacrificio</span> y{' '}
            <span className="bg-yellow-300 px-1" data-id="element-49">
              sin volver a pelear con tu mente
            </span>
          </p>

          <CTAButton data-id="element-50">👉 SÍ, QUIERO ACCEDER AHORA</CTAButton>
        </div>
      </section>

      {/* PROBLEM SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-51">
        <div className="max-w-3xl mx-auto" data-id="element-52">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-53">
            Si estás cansado de luchar contra vos mismo, dejame preguntarte algo
            honesto:
          </h2>

          <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-54">
            <p className="font-medium" data-id="element-55">
              ¿Seguís "bien"… pero con la cabeza vigilando, con miedo a recaer,
              o con esa sensación de que en cualquier momento puede volver?
            </p>
            <p data-id="element-56">No porque seas débil. No porque no tengas carácter.</p>
            <p className="text-xl font-bold text-gray-900" data-id="element-57">
              Sino porque te enseñaron que esto se gana luchando.
            </p>
            <p data-id="element-58">Y luchar cansa. Siempre.</p>
            <p data-id="element-59">
              Pensar en no hacerlo. Evitar estímulos. Controlarte. Aguantar
              impulsos. Sentirte "fuerte" un día… y agotado al siguiente.
            </p>
            <p data-id="element-60">Y aunque lo dejes, la pelea sigue en la cabeza.</p>
            <p className="text-center font-bold text-2xl mt-8 border-l-4 border-[#dc2626] pl-4 py-2 bg-red-50" data-id="element-61">
              Salir no debería sentirse así.
            </p>
          </div>

          <div className="mt-12" data-id="element-62">
            <CTAButton data-id="element-63">QUIERO TERMINAR CON ESTA LUCHA</CTAButton>
          </div>
        </div>
      </section>

      {/* PAIN POINTS SECTION */}
      <section className="py-16 px-4 bg-gray-900 text-white" data-id="element-64">
        <div className="max-w-4xl mx-auto" data-id="element-65">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-yellow-400" data-id="element-66">
            El problema que nadie explica bien
          </h2>

          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-67">
            <div className="space-y-4" data-id="element-68">
              <p className="text-xl font-medium mb-6" data-id="element-69">
                Si esto te resulta familiar, no estás solo:
              </p>
              <ul className="space-y-4" data-id="element-70">
                {['Dejaste el porno, pero seguís vigilándote', 'Hay momentos de calma… y otros de tensión', 'El impulso aparece aunque "no quieras"', 'Vivís en estado de alerta mental', 'Tenés miedo de volver a caer'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-71">
                    <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-72" />
                    <span className="text-lg" data-id="element-73">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-gray-800 p-8 rounded-xl border border-gray-700" data-id="element-74">
              <p className="text-lg mb-6" data-id="element-75">
                Lo peor no es el deseo. Es esa sensación constante de:
              </p>
              <p className="text-2xl font-bold italic text-gray-300 mb-8" data-id="element-76">
                "Si bajo la guardia, pierdo."
              </p>

              <div className="space-y-2 font-bold text-red-400 text-xl" data-id="element-77">
                <p data-id="element-78">❌ No es falta de fuerza</p>
                <p data-id="element-79">❌ No es que "no puedas"</p>
              </div>

              <p className="mt-6 text-gray-300" data-id="element-80">
                La mayoría no falla por debilidad. Falla porque está peleando
                contra algo mal entendido.
              </p>
            </div>
          </div>

          <div className="mt-12 text-center" data-id="element-81">
            <p className="text-xl mb-8" data-id="element-82">
              👉 Mientras creas que esto se soluciona con control, la lucha va a
              seguir.
            </p>
            <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 max-w-3xl mx-auto mb-8" data-id="element-83">
              <h3 className="text-xl font-bold text-red-400 mb-4" data-id="element-84">
                ❌ El gran error que casi todos cometen
              </h3>
              <p className="text-gray-300 mb-4" data-id="element-85">
                La mayoría de los métodos parten de esta idea: "Hay algo
                poderoso en esto… y yo tengo que vencerlo."
              </p>
              <p className="text-gray-300 mb-4" data-id="element-86">
                Eso crea: Vigilancia constante, Miedo a recaer, Identidad de
                "luchador", Cansancio mental crónico.
              </p>
              <p className="text-gray-300" data-id="element-87">
                Aunque aguantes un tiempo, la lucha siempre deja cicatrices.
              </p>
            </div>
            <p className="text-2xl font-bold text-[#22c55e]" data-id="element-88">
              👉 SALIR SIN LUCHAR cambia completamente este paradigma.
            </p>
          </div>
        </div>
      </section>

      {/* SOLUTION SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-89">
        <div className="max-w-5xl mx-auto" data-id="element-90">
          <div className="text-center mb-16" data-id="element-91">
            <span className="bg-green-100 text-green-800 px-4 py-1 rounded-full font-bold text-sm uppercase tracking-wide" data-id="element-92">
              ✅ LA SOLUCIÓN
            </span>
            <h2 className="text-4xl md:text-5xl font-black mt-6 mb-4" data-id="element-93">
              MegaPack · SALIR SIN LUCHAR
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-94">
              No es fuerza de voluntad. No es motivación. No es terapia. Y no es
              una guerra contra vos mismo.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-95">
            <div className="bg-green-50 p-8 rounded-2xl border border-green-100" data-id="element-96">
              <h3 className="text-2xl font-bold mb-6" data-id="element-97">
                Es un sistema diseñado para que la lucha deje de ser necesaria.
              </h3>
              <p className="text-lg text-gray-700 mb-4" data-id="element-98">
                Porque cuando entendés cómo funciona el engaño mental:
              </p>
              <ul className="space-y-4" data-id="element-99">
                {['El deseo pierde valor', 'Lo que pierde valor deja de dominar', 'Y lo que no domina… no necesita resistencia'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-100">
                    <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-101" />
                    <span className="text-lg font-medium text-gray-800" data-id="element-102">
                      {item}
                    </span>
                  </li>)}
              </ul>
              <p className="mt-6 font-bold text-green-800" data-id="element-103">
                👉 No se trata de resistir impulsos. 👉 Se trata de ver por qué
                nunca fueron lo que parecían.
              </p>
            </div>

            <div className="flex flex-col justify-center items-center text-center p-8 bg-gray-50 rounded-2xl border border-gray-100" data-id="element-104">
              <h3 className="text-2xl font-bold mb-6 text-gray-900" data-id="element-105">
                ¿Qué pasaría si…?
              </h3>
              <div className="space-y-6 text-xl font-bold text-gray-800" data-id="element-106">
                <div className="flex items-start gap-4" data-id="element-107">
                  <span className="w-8 h-8 bg-black text-white rounded-full flex items-center justify-center text-sm flex-shrink-0 mt-1" data-id="element-108">
                    1
                  </span>
                  <span className="text-left" data-id="element-109">
                    El impulso no fuera una fuerza real, sino una ilusión
                    aprendida
                  </span>
                </div>
                <div className="flex items-start gap-4" data-id="element-110">
                  <span className="w-8 h-8 bg-black text-white rounded-full flex items-center justify-center text-sm flex-shrink-0 mt-1" data-id="element-111">
                    2
                  </span>
                  <span className="text-left" data-id="element-112">
                    El placer no fuera placer, sino alivio mal interpretado
                  </span>
                </div>
                <div className="flex items-start gap-4" data-id="element-113">
                  <span className="w-8 h-8 bg-black text-white rounded-full flex items-center justify-center text-sm flex-shrink-0 mt-1" data-id="element-114">
                    3
                  </span>
                  <span className="text-left" data-id="element-115">
                    El cerebro no fuera tu enemigo, sino un sistema que repite
                    lo que cree valioso
                  </span>
                </div>
              </div>
              <p className="mt-8 text-lg text-gray-600 italic" data-id="element-116">
                👉 Eso es lo que este sistema te muestra, paso a paso.
              </p>
            </div>
          </div>

          <CTAButton data-id="element-117">QUIERO EMPEZAR AHORA</CTAButton>
        </div>
      </section>

      {/* MODULES SECTION */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-118">
        <div className="max-w-5xl mx-auto" data-id="element-119">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4" data-id="element-120">
            📘 ¿Qué incluye exactamente SALIR SIN LUCHAR?
          </h2>
          <p className="text-center text-xl text-gray-600 mb-12" data-id="element-121">
            🔹 6 TOMOS PRINCIPALES: Un recorrido claro, profundo y definitivo.
          </p>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-122">
            {[{
            icon: '📕',
            title: 'Tomo 1 – El Engaño Invisible',
            desc: 'Descubrís por qué nunca fue tan poderoso como parecía y cómo la ilusión se sostiene solo mientras no se la ve.'
          }, {
            icon: '📘',
            title: 'Tomo 2 – El Mito del Placer',
            desc: 'Entendés por qué no hay placer real ahí, solo alivio temporal que genera más necesidad.'
          }, {
            icon: '📗',
            title: 'Tomo 3 – El Cerebro Desprogramado',
            desc: 'Aprendés cómo el cerebro deja de proponer cuando algo pierde sentido de verdad.'
          }, {
            icon: '📙',
            title: 'Tomo 4 – El Momento de Libertad',
            desc: 'Reconocés el instante exacto en que la lucha termina y la libertad se vuelve un hecho silencioso.'
          }, {
            icon: '📕',
            title: 'Tomo 5 – Vida Sin Ruido',
            desc: 'Descubrís cómo se vive cuando el fondo mental desaparece y la mente deja de interferir.'
          }, {
            icon: '📒',
            title: 'Tomo 6 – Blindaje Mental',
            desc: 'Entendés por qué esto no se pierde, por qué no hay recaída y por qué no hace falta mantenimiento.'
          }].map((tomo, i) => <a href={SECTION_LINK} key={i} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow cursor-pointer" data-id="element-123">
                <div className="text-4xl mb-4" data-id="element-124">{tomo.icon}</div>
                <h3 className="text-xl font-bold mb-2" data-id="element-125">{tomo.title}</h3>
                <p className="text-gray-600" data-id="element-126">{tomo.desc}</p>
              </a>)}
          </div>

          <p className="text-center text-lg font-medium mt-12 text-gray-700" data-id="element-127">
            👉 Todo organizado para comprender, no para aguantar.
          </p>
        </div>
      </section>

      {/* BEFORE VS AFTER */}
      <section className="py-16 px-4 bg-white" data-id="element-128">
        <div className="max-w-4xl mx-auto" data-id="element-129">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-130">
            🔄 Antes vs Después
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-131">
            <div className="bg-red-50 p-8 rounded-2xl border border-red-100" data-id="element-132">
              <h3 className="text-xl font-bold text-red-800 mb-6 text-center" data-id="element-133">
                Antes de SALIR SIN LUCHAR
              </h3>
              <ul className="space-y-4" data-id="element-134">
                {['Vigilancia constante', 'Impulsos con peso', 'Miedo a recaer', 'Cansancio mental', 'Vida en tensión'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-135">
                    <XIcon className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-136" />
                    <span className="text-gray-700" data-id="element-137">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-green-50 p-8 rounded-2xl border border-green-100 shadow-lg transform md:-translate-y-4" data-id="element-138">
              <h3 className="text-xl font-bold text-green-800 mb-6 text-center" data-id="element-139">
                Después de SALIR SIN LUCHAR
              </h3>
              <ul className="space-y-4" data-id="element-140">
                {['El impulso pierde valor', 'La vigilancia desaparece', 'La mente descansa', 'El cuerpo deja de anticipar', 'La vida se vive directa'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-141">
                    <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-142" />
                    <span className="font-bold text-gray-800" data-id="element-143">{item}</span>
                  </li>)}
              </ul>
              <p className="mt-6 text-center text-green-800 font-medium italic" data-id="element-144">
                No porque "te portás bien". Sino porque ya no hay nada que
                sostener.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BONUSES SECTION */}
      <section className="py-16 px-4 bg-[#0f172a] text-white" data-id="element-145">
        <div className="max-w-5xl mx-auto" data-id="element-146">
          <div className="text-center mb-12" data-id="element-147">
            <span className="bg-yellow-400 text-black px-4 py-1 rounded-full font-bold text-sm uppercase tracking-wide animate-pulse" data-id="element-148">
              🎁 BONOS INCLUIDOS HOY
            </span>
            <h2 className="text-3xl md:text-5xl font-bold mt-6 mb-4" data-id="element-149">
              GRATIS POR TIEMPO LIMITADO
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-150">
            <a href={SECTION_LINK} className="bg-[#1e293b] rounded-xl p-6 border border-[#334155] flex flex-col items-center text-center hover:border-yellow-400 transition-colors cursor-pointer" data-id="element-151">
              <div className="w-full aspect-square max-w-[270px] mb-6 flex items-center justify-center rounded-lg bg-[#1e293b]" data-id="element-152">
                <img src={BONUS_1_IMAGE} alt="Bono 1 - Cuando Aparece la Duda" className="w-full h-full object-contain drop-shadow-xl" data-id="element-153" />
              </div>
              <span className="bg-yellow-400 text-black px-3 py-1 rounded-full text-xs font-bold mb-3" data-id="element-154">
                GRATIS HOY
              </span>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-155">
                🎁 Bono #1 – Cuando Aparece la Duda
              </h3>
              <p className="text-gray-300 text-sm" data-id="element-156">
                Para entender por qué la duda no es peligrosa y cómo se apaga
                sola cuando no se la dramatiza.
              </p>
              <p className="text-yellow-400 text-xs mt-2 font-bold" data-id="element-157">
                👉 Ideal para cerrar el proceso sin miedo.
              </p>
            </a>

            <a href={SECTION_LINK} className="bg-[#1e293b] rounded-xl p-6 border border-[#334155] flex flex-col items-center text-center hover:border-yellow-400 transition-colors cursor-pointer" data-id="element-158">
              <div className="w-full aspect-square max-w-[270px] mb-6 flex items-center justify-center rounded-lg bg-[#1e293b]" data-id="element-159">
                <img src={BONUS_2_IMAGE} alt="Bono 2 - Sin Volver a Luchar" className="w-full h-full object-contain drop-shadow-xl" data-id="element-160" />
              </div>
              <span className="bg-yellow-400 text-black px-3 py-1 rounded-full text-xs font-bold mb-3" data-id="element-161">
                GRATIS HOY
              </span>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-162">
                🎁 Bono #2 – Sin Volver a Luchar
              </h3>
              <p className="text-gray-300 text-sm" data-id="element-163">
                Para atravesar estrés, cansancio o días difíciles sin volver a
                viejos mecanismos.
              </p>
              <p className="text-yellow-400 text-xs mt-2 font-bold" data-id="element-164">
                👉 La vida real no rompe lo que ya se entendió.
              </p>
            </a>

            <a href={SECTION_LINK} className="bg-[#1e293b] rounded-xl p-6 border border-[#334155] flex flex-col items-center text-center hover:border-yellow-400 transition-colors cursor-pointer" data-id="element-165">
              <div className="w-full aspect-square max-w-[270px] mb-6 flex items-center justify-center rounded-lg bg-[#1e293b]" data-id="element-166">
                <img src={BONUS_3_IMAGE} alt="Bono 3 - La Mirada Correcta" className="w-full h-full object-contain drop-shadow-xl" data-id="element-167" />
              </div>
              <span className="bg-yellow-400 text-black px-3 py-1 rounded-full text-xs font-bold mb-3" data-id="element-168">
                GRATIS HOY
              </span>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-169">
                🎁 Bono #3 – La Mirada Correcta
              </h3>
              <p className="text-gray-300 text-sm" data-id="element-170">
                Para vivir en el mundo sin evitar, sin filtrar, sin cuidarte.
              </p>
              <p className="text-yellow-400 text-xs mt-2 font-bold" data-id="element-171">
                👉 Cuando la percepción se ordena, nada engancha.
              </p>
            </a>
          </div>

          <div className="mt-12 text-center space-y-2 text-lg font-medium" data-id="element-172">
            <p data-id="element-173">👉 Los tomos generan comprensión.</p>
            <p data-id="element-174">👉 Los bonos evitan que vuelvas a interpretar mal.</p>
            <p className="text-yellow-400 font-bold text-xl mt-4" data-id="element-175">
              Eso es lo que vuelve esto definitivo.
            </p>
          </div>

          <div className="mt-12" data-id="element-176">
            <CTAButton data-id="element-177">QUIERO MIS REGALOS AHORA</CTAButton>
          </div>
        </div>
      </section>

      {/* OFFER STACK SECTION */}
      <section id="compra" className="py-16 px-4 bg-gradient-to-b from-gray-900 to-gray-800" data-id="element-178">
        <div className="max-w-4xl mx-auto" data-id="element-179">
          <div className="text-center mb-10" data-id="element-180">
            <span className="bg-red-500 text-white px-4 py-2 rounded-full font-bold text-sm uppercase tracking-wide animate-pulse inline-block mb-4" data-id="element-181">
              ⏰ OFERTA ESPECIAL
            </span>
            <h2 className="text-4xl md:text-6xl font-black text-white uppercase leading-tight" data-id="element-182">
              TIEMPO LIMITADO
            </h2>
          </div>

          <div className="bg-white rounded-3xl p-6 md:p-12 shadow-2xl" data-id="element-183">
            <h3 className="text-2xl md:text-3xl font-black text-center mb-8 text-gray-900" data-id="element-184">
              📦 Lo que recibís hoy
            </h3>

            <div className="space-y-4 mb-10" data-id="element-185">
              {['6 tomos completos de SALIR SIN LUCHAR', 'Bono Cuando Aparece la Duda', 'Bono Sin Volver a Luchar', 'Bono La Mirada Correcta', 'Acceso digital inmediato', 'Acceso de por vida'].map((item, i) => <div key={i} className="flex items-center gap-3 text-lg md:text-xl border-b border-gray-200 pb-3 last:border-0" data-id="element-186">
                  <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-187" />
                  <span className="font-bold text-gray-800" data-id="element-188">{item}</span>
                </div>)}
            </div>

            <div className="text-center mb-8" data-id="element-189">
              <p className="text-gray-500 text-xl mb-2" data-id="element-190">
                Precio regular:{' '}
                <span className="line-through decoration-red-500 decoration-2" data-id="element-191">
                  49.990ARS
                </span>
              </p>
              <p className="text-5xl md:text-7xl font-black text-[#22c55e]" data-id="element-192">
                🔥 19.990 ARS
              </p>
              <p className="text-gray-600 mt-2 font-medium" data-id="element-193">Solo por hoy</p>
            </div>

            <div className="flex flex-col items-center justify-center w-full" data-id="element-194">
              <a href="https://checkout.tumundoglobal.online/cart/45152309608639:1" className="relative group flex items-center justify-center gap-2 w-full md:max-w-2xl px-6 py-5 md:py-6 bg-[#22c55e] hover:bg-[#16a34a] text-white text-center rounded-xl shadow-xl hover:shadow-2xl transform transition-all duration-200 hover:-translate-y-1 border-b-4 border-[#15803d] active:border-b-0 active:translate-y-1 text-xl md:text-2xl font-bold uppercase tracking-wide" data-id="element-195">
                👉 SALIR SIN LUCHAR AHORA
                <ArrowRightIcon className="w-6 h-6 md:w-7 md:h-7" data-id="element-196" />
              </a>
            </div>
          </div>

          <div className="mt-10 flex flex-col md:flex-row items-center gap-6 bg-white/10 backdrop-blur-sm p-6 rounded-2xl border border-white/20" data-id="element-197">
            <ShieldCheckIcon className="w-16 h-16 text-yellow-400 flex-shrink-0" data-id="element-198" />
            <div className="text-center md:text-left" data-id="element-199">
              <h3 className="text-xl font-bold mb-2 text-white" data-id="element-200">
                🛡️ Garantía sin lucha
              </h3>
              <p className="text-gray-300" data-id="element-201">
                Probalo durante 7 días. Si no es para vos, te devolvemos el 100%
                del dinero. Sin preguntas. Sin presión. Sin discusiones.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* PREVIEW PAGES CAROUSEL */}
      <section className="py-16 px-4 bg-white" data-id="element-202">
        <div className="max-w-4xl mx-auto" data-id="element-203">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4" data-id="element-204">
            📖 Revisá algunas hojas
          </h2>
          <p className="text-center text-gray-600 mb-10" data-id="element-205">
            Mirá una muestra del contenido que vas a recibir
          </p>

          <div className="relative" data-id="element-206">
            <div className="relative overflow-hidden rounded-2xl shadow-2xl bg-gray-100" data-id="element-207">
              <img src={PREVIEW_PAGES[currentPage]} alt={`Hoja ${currentPage + 1} del MegaPack`} className="w-full h-auto" data-id="element-208" />
            </div>

            <button onClick={prevPage} className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 w-12 h-12 md:w-14 md:h-14 bg-white/90 hover:bg-white rounded-full shadow-lg flex items-center justify-center transition-all hover:scale-110" aria-label="Página anterior" data-id="element-209">
              <ChevronLeftIcon className="w-6 h-6 md:w-8 md:h-8 text-gray-800" data-id="element-210" />
            </button>
            <button onClick={nextPage} className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 w-12 h-12 md:w-14 md:h-14 bg-white/90 hover:bg-white rounded-full shadow-lg flex items-center justify-center transition-all hover:scale-110" aria-label="Página siguiente" data-id="element-211">
              <ChevronRightIcon className="w-6 h-6 md:w-8 md:h-8 text-gray-800" data-id="element-212" />
            </button>

            <div className="flex justify-center gap-2 mt-6" data-id="element-213">
              {PREVIEW_PAGES.map((_, index) => <button key={index} onClick={() => setCurrentPage(index)} className={`w-3 h-3 rounded-full transition-all ${index === currentPage ? 'bg-[#22c55e] w-8' : 'bg-gray-300 hover:bg-gray-400'}`} aria-label={`Ir a hoja ${index + 1}`} data-id="element-214" />)}
            </div>
          </div>

          <p className="text-center text-gray-500 mt-4 font-medium" data-id="element-215">
            Hoja {currentPage + 1} de {PREVIEW_PAGES.length}
          </p>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-216">
        <div className="max-w-6xl mx-auto" data-id="element-217">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-218">
            Lo que dicen quienes ya lo probaron
          </h2>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-219">
            <TestimonialCard name="Lucas" age={32} location="Buenos Aires" quote="Llevaba años intentando dejarlo con fuerza de voluntad y siempre caía. Entender el mecanismo mental fue la clave para soltarlo sin sufrir." data-id="element-220" />
            <TestimonialCard name="Martín" age={28} location="Córdoba" quote="Pensé que iba a ser otra lucha más, pero fue todo lo contrario. La ansiedad desapareció cuando dejé de pelear contra ella." data-id="element-221" />
            <TestimonialCard name="Javier" age={41} location="Rosario" quote="Increíble cómo cambia todo cuando dejás de vigilarte. Recuperé mi paz mental y mi energía diaria." data-id="element-222" />
          </div>
          <div className="grid md:grid-cols-3 gap-6 mt-6" data-id="element-223">
            <TestimonialCard name="Diego" age={35} location="Mendoza" quote="Lo mejor es que no siento que me estoy prohibiendo nada. Simplemente ya no lo necesito. Es una libertad real." data-id="element-224" />
            <TestimonialCard name="Pablo" age={29} location="La Plata" quote="Los bonos son oro puro. Me ayudaron a entender mis momentos de duda y a no dramatizarlos. Recomendadísimo." data-id="element-225" />
            <TestimonialCard name="Andrés" age={37} location="Santa Fe" quote="Después de leer el tomo 2 entendí que lo que creía placer era solo alivio. Eso me cambió la cabeza para siempre. Ya no hay nada contra qué pelear." data-id="element-226" />
          </div>
        </div>
      </section>

      {/* FAQ SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-227">
        <div className="max-w-3xl mx-auto" data-id="element-228">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-229">
            ❓ Preguntas frecuentes
          </h2>
          <FAQAccordion data-id="element-230" />
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="py-20 px-4 bg-gray-900 text-white text-center" data-id="element-231">
        <div className="max-w-3xl mx-auto" data-id="element-232">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-233">
            🧠 Una última verdad
          </h2>
          <p className="text-xl text-gray-300 mb-10 leading-relaxed" data-id="element-234">
            Lo que se sostiene por lucha se pierde por cansancio.
            <br className="hidden md:block" data-id="element-235" />
            <span className="md:hidden" data-id="element-236"> </span>
            Lo que se sostiene por comprensión no se pierde.
          </p>

          <p className="text-xl text-gray-300 mb-10 -mt-4 leading-relaxed" data-id="element-237">
            👉 SALIR SIN LUCHAR: El sistema completo para que la libertad deje
            de ser un esfuerzo.
          </p>

          <a href={SECTION_LINK} className="inline-flex flex-col items-center justify-center px-12 py-5 md:py-6 bg-[#22c55e] hover:bg-[#16a34a] text-white text-center rounded-xl shadow-xl hover:shadow-2xl transform transition-all duration-200 hover:-translate-y-1 border-b-4 border-[#15803d] active:border-b-0 active:translate-y-1" data-id="element-238">
            <span className="text-lg md:text-xl font-bold uppercase tracking-wide" data-id="element-239">
              ACCEDÉ AHORA
            </span>
          </a>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="py-8 bg-black text-gray-500 text-center text-sm" data-id="element-240">
        <p data-id="element-241">© 2024 Salir Sin Luchar. Todos los derechos reservados.</p>
        <p className="mt-2" data-id="element-242">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
        </p>
      </footer>
    </div>;
}